<div class="ng-autocomplete w-100">  
      <ng-autocomplete 
        #searchInput
        [class]='classSearch'
        [data]="data"
        [searchKeyword]="keyword"
        placeholder="Buscar paquete turístico"
        (selected)='selectSearch($event)'
        (inputChanged)='debouncedSearchInput($event)' 
        (inputCleared)='clearedInputSearch()'                              
        (closed)='closedSearchPanel()'                              
        [itemTemplate]="itemTemplate"
        [notFoundTemplate]="notFoundTemplate">                                 
      </ng-autocomplete>
      <ng-template #itemTemplate let-item>
        <a style="padding: 8px 15px;" class="f-s-12 p-10" [innerHTML]="item.description"></a>
        <ng-container *ngIf="item.is_special_offer">
          <div class="p-l-15" style="margin-top:-13px;">
            <span class="badge f-s-9 text-white" [ngStyle]="{'background-color': item.special_offer.bg_color}">{{item.special_offer.description}}</span>
          </div>          
        </ng-container>
        
      </ng-template>   
      <ng-template #notFoundTemplate let-notFound>
        <p style="padding-top: 5px;
        margin-bottom: 5px;
        font-weight: 500;" *ngIf="isTypedSearch">No se encontraron registros</p>
      </ng-template>
  </div>